import { fulfillmentApi } from '@/api';
import PaginationOutput from '@/helpers/PaginationOutput';
import AllocatableWorkerVM from '@/view-model/AllocatableWorkerVM';
import FulfillmentVM from '@/view-model/list-control/FulfillmentVM';
export default {
    /**
     * 수행상황 조회
     * @param distId 총판 아이디
     * @param hubId 허브 아이디 (허브 아이디 없으면 총판 조회)
     */
    async getFulfillment(distId, hubId = '') {
        let response;
        if (hubId) {
            response = await fulfillmentApi.getFulfillmentByHub(distId, hubId);
        }
        else {
            response = await fulfillmentApi.getFulfillmentByDist(distId);
        }
        return PaginationOutput.adaptorFactory(response, FulfillmentVM);
    },
    /**
     * 라이더별 풀필먼트 조회
     * @param distId 총판 아이디
     * @param hubId 허브 아이디
     * @param workerId 라이더 아이디
     */
    async getFulfillmentByWorker(distId, hubId, workerId) {
        const response = await fulfillmentApi.getFulfillmentByWorker(distId, hubId, workerId);
        return new FulfillmentVM(response.data.data);
    },
    /**
     * 현재 수행 가능 라이더 조회
     * @param orderId 주문 아이디
     */
    async getAllocatableWorker(orderId) {
        const response = await fulfillmentApi.getAllocatableWorker(orderId);
        return response.data.data.map((item) => new AllocatableWorkerVM(item));
    },
};
